import { __ } from 'bits/intl'

export const CONFIRM_DISCARD_CHANGES: { [key: string]: string } = {
  title: __('You have unsaved changes'),
  body: __('Are you sure you want to discard them and close this panel?'),
  confirmButtonText: __('Discard and close'),
  cancelButtonText: __('Keep working'),
}

export const SAVE_CHANGES_FAILED: { [key: string]: string } = {
  message: __("Sorry, we couldn't save your changes. Please refresh the page."),
  actionText: __('Refresh'),
  actionName: 'reloadPage',
}

export default {
  CONFIRM_DISCARD_CHANGES,
  SAVE_CHANGES_FAILED,
}
